import axios from 'axios';
import { APIS, HOST } from '../constants/apis';

// export async function Login(dateJson: ISigninForm) {
//   console.log("dateJson", dateJson);

//   return await axiosInstance.post(APIS.login, dateJson);
// }
// export const Login = (email: ISigninForm): Promise<IResponse<ILogin>> => {
//   return axiosInstance.post(APIS.login, data);
// };
export async function Login(username: string, password: string) {
  console.log('Email', username, password);
  // let _res = axiosInstance.post(APIS.LoginUser, {
  //   username: username,
  //   password: password,
  // });
  // console.log('_res', _res);

  try {
    const respone = await axios({
      method: 'post',
      url: HOST.localUrl + APIS.LoginUser,
      data: {
        username: username,
        password: password,
      },
    })
      .then(function (response) {
        return response;
      })
      .catch(function (response) {
        return response;
      });

    return respone;
  } catch (error) {
    console.log({ error });
  }
}
// export {};
